import React from 'react';
import { motion } from 'framer-motion';
import WorkflowCanvas from './WorkflowCanvas';

const nodes = [
  {
    id: 'field',
    x: 40, y: 200, w: 160, h: 76,
    label: 'Field Request',
    icon: '📱',
    desc: 'Tech or site manager submits via portal or phone',
    color: '#22c55e',
    badge: 'New',
    badgeBg: '#dcfce7',
    badgeColor: '#16a34a',
  },
  {
    id: 'voice',
    x: 40, y: 340, w: 160, h: 76,
    label: 'AI Voice Intake',
    icon: '🎙️',
    desc: 'Field tech calls in — AI agent captures issue',
    color: '#8b5cf6',
    badge: 'Add-On',
    badgeBg: '#ede9fe',
    badgeColor: '#7c3aed',
  },
  {
    id: 'auto',
    x: 275, y: 260, w: 160, h: 76,
    label: 'Auto-Classified',
    icon: '⚡',
    desc: 'Type, priority, and queue assigned',
    color: '#8b5cf6',
  },
  {
    id: 'asset-link',
    x: 510, y: 100, w: 165, h: 76,
    label: 'Asset Identified',
    icon: '🔗',
    desc: 'Linked to specific asset record',
    color: '#f97316',
  },
  {
    id: 'queue',
    x: 510, y: 240, w: 165, h: 76,
    label: 'Routed to Queue',
    icon: '📬',
    desc: 'IT, Maintenance, or Field ops queue',
    color: '#3b82f6',
  },
  {
    id: 'notify',
    x: 510, y: 380, w: 165, h: 76,
    label: 'Team Notified',
    icon: '🔔',
    desc: 'Right person alerted with full context',
    color: '#eab308',
  },
  {
    id: 'work',
    x: 750, y: 170, w: 160, h: 76,
    label: 'Work Performed',
    icon: '🔧',
    desc: 'On-site or remote resolution',
    color: '#22c55e',
  },
  {
    id: 'asset-updated',
    x: 750, y: 340, w: 160, h: 76,
    label: 'Asset Record Updated',
    icon: '📋',
    desc: 'Status, history, and location logged',
    color: '#0ea5e9',
  },
  {
    id: 'resolved',
    x: 985, y: 170, w: 160, h: 76,
    label: 'Ticket Resolved',
    icon: '✅',
    desc: 'Issue closed, requester confirmed',
    color: '#22c55e',
  },
  {
    id: 'report',
    x: 985, y: 310, w: 160, h: 76,
    label: 'Ops Dashboard',
    icon: '📊',
    desc: 'Managers see volume, SLAs, asset health',
    color: '#a855f7',
  },
];

const edges = [
  { from: 'field', to: 'auto' },
  { from: 'voice', to: 'auto', label: 'Add-On', dashed: true },
  { from: 'auto', to: 'asset-link', label: 'Asset' },
  { from: 'auto', to: 'queue', label: 'Route' },
  { from: 'auto', to: 'notify' },
  { from: 'asset-link', to: 'work' },
  { from: 'queue', to: 'work' },
  { from: 'notify', to: 'asset-updated', dashed: true },
  { from: 'work', to: 'resolved' },
  { from: 'asset-updated', to: 'report' },
  { from: 'resolved', to: 'report' },
];

export default function AIVoiceWorkflow() {
  return (
    <section className="py-20" style={{ background: '#ffffff' }}>
      <div className="max-w-6xl mx-auto px-8 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-8">
          <p className="text-xs font-bold uppercase tracking-widest mb-3" style={{ color: '#16a34a' }}>System Flow</p>
          <h2 className="text-2xl md:text-3xl font-bold mb-2" style={{ color: '#052e16' }}>
            From field request to asset record — automatically.
          </h2>
          <p className="text-sm leading-relaxed max-w-xl" style={{ color: '#374151' }}>
            Every support request is classified, routed, and linked to the affected asset. AI voice intake is an optional add-on for field teams that prefer calling over a portal.
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}>
          <WorkflowCanvas
            nodes={nodes}
            edges={edges}
            title="Asset Ops Request Flow"
            label="ASSET OPS"
            canvasHeight={560}
          />
        </motion.div>
      </div>
    </section>
  );
}